import script from "./SiteVisitRequestsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./SiteVisitRequestsPage.vue?vue&type=script&lang=ts&setup=true"

import "./SiteVisitRequestsPage.vue?vue&type=style&index=0&id=60123a9c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60123a9c"]])

export default __exports__